"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getImageFetchingErrorMessage = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var Types_1 = require("../../Types");
var getImageFetchingErrorMessage = function (selectedSystemFolderId, showQwilrStockImages) {
    switch (selectedSystemFolderId) {
        case Types_1.ImageLibrarySystemFolder.Unsplash:
            return {
                header: "Unsplash is temporarily unavailable",
                content: (react_1.default.createElement("div", null,
                    "Try again in a few minutes, or ",
                    react_1.default.createElement(kaleidoscope_1.Link, { onClick: showQwilrStockImages }, "explore our Qwilr collection"),
                    " in the meantime")),
            };
        case Types_1.ImageLibrarySystemFolder.Uploads:
            return {
                header: "We couldn’t load your uploaded images",
                content: react_1.default.createElement("div", null, "Please check your internet connection and refresh the page"),
            };
        case Types_1.ImageLibrarySystemFolder.RecentlyUsed:
            return {
                header: "We couldn’t load your recently used images",
                content: react_1.default.createElement("div", null, "Please check your internet connection and refresh the page"),
            };
        default:
            return undefined;
    }
};
exports.getImageFetchingErrorMessage = getImageFetchingErrorMessage;
